import { Box, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledPaper = styled(Paper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(3),
}));

interface StyledTextContainerProps {
  gap?: number;
}

export const StyledTextContainer = styled(Box)<StyledTextContainerProps>(({ theme, gap = 1 }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(gap),
  [theme.breakpoints.down('sm')]: {
    flexWrap: 'wrap',
  },
}));
